import React from 'react';
import { Box, Grid } from '@mui/material';
import SearchFilter from '../../../components/SearchFilter';

const OverviewListFilter = ({
  filters,
  selectedFilter,
  onFilterChange,
  searchTerm,
  onSearchChange,
  onSearchKeyPress,
}) => {
  const searchFilters = filters.filter((filter) => filter.type === 'search');

  return (
    <Grid item xs={12} alignItems="center" spacing={1}>
      <Grid item>
        <Box display="flex" gap={0.5} width="100%" mb="1">
          {searchFilters.map((filter) => (
            <SearchFilter
              key={filter.type}
              filter={filter}
              selectedFilter={selectedFilter}
              onFilterChange={onFilterChange}
              searchTerm={searchTerm}
              onSearchChange={onSearchChange}
              onSearchKeyPress={onSearchKeyPress}
            />
          ))}
        </Box>
      </Grid>
    </Grid>
  );
};

export default OverviewListFilter;
